// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { AddressDTO } from '../models';
import { ChangeInstalmentDatesDTO } from '../models';
import { CreatePaymentPlanDTO } from '../models';
import { PaymentPlanDTO } from '../models';
import { PaymentPlanWithInstalmentsDTO } from '../models';
import { SetupIntentSecretDTO } from '../models';
import { UpdatePaymentPlanTenantDeferralDTO } from '../models';
/**
 * PaymentPlansApi - axios parameter creator
 * @export
 */
export const PaymentPlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Updates the payment date for all future instalments on a payment plan
         * @summary Change payment date for future instalments
         * @param {string} id Payment plan ID
         * @param {ChangeInstalmentDatesDTO} changeInstalmentDatesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeInstalmentDates(id: string, changeInstalmentDatesDTO: ChangeInstalmentDatesDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling changeInstalmentDates.');
            }
            // verify required parameter 'changeInstalmentDatesDTO' is not null or undefined
            if (changeInstalmentDatesDTO === null || changeInstalmentDatesDTO === undefined) {
                throw new RequiredError('changeInstalmentDatesDTO','Required parameter changeInstalmentDatesDTO was null or undefined when calling changeInstalmentDates.');
            }
            const localVarPath = `/v2/payment-plan/{id}/change-instalment-dates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"ChangeInstalmentDatesDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(changeInstalmentDatesDTO !== undefined ? changeInstalmentDatesDTO : {}) : (changeInstalmentDatesDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a payment plan for a user
         * @param {CreatePaymentPlanDTO} createPaymentPlanDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentPlan(createPaymentPlanDTO: CreatePaymentPlanDTO, options: any = {}): RequestArgs {
            // verify required parameter 'createPaymentPlanDTO' is not null or undefined
            if (createPaymentPlanDTO === null || createPaymentPlanDTO === undefined) {
                throw new RequiredError('createPaymentPlanDTO','Required parameter createPaymentPlanDTO was null or undefined when calling createPaymentPlan.');
            }
            const localVarPath = `/v2/payment-plan`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreatePaymentPlanDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createPaymentPlanDTO !== undefined ? createPaymentPlanDTO : {}) : (createPaymentPlanDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a Payment Plan By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentPlanById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deletePaymentPlanById.');
            }
            const localVarPath = `/v2/payment-plan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Force delete a Payment Plan By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceDeletePaymentPlanById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling forceDeletePaymentPlanById.');
            }
            const localVarPath = `/v2/payment-plan/{id}/force`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Payment Plan By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentPlanById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPaymentPlanById.');
            }
            const localVarPath = `/v2/payment-plan/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Payment Plan Property Address By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentPlanPropertyAddressById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getPaymentPlanPropertyAddressById.');
            }
            const localVarPath = `/v2/payment-plan/{id}/address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a setup intent for a payment plan and return the secret
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetupIntentSecret(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSetupIntentSecret.');
            }
            const localVarPath = `/v2/payment-plan/{id}/setup-intent`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable tenant instalment deferral on a payment plan
         * @param {string} id Payment plan ID
         * @param {UpdatePaymentPlanTenantDeferralDTO} updatePaymentPlanTenantDeferralDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentPlanTenantDeferral(id: string, updatePaymentPlanTenantDeferralDTO: UpdatePaymentPlanTenantDeferralDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updatePaymentPlanTenantDeferral.');
            }
            // verify required parameter 'updatePaymentPlanTenantDeferralDTO' is not null or undefined
            if (updatePaymentPlanTenantDeferralDTO === null || updatePaymentPlanTenantDeferralDTO === undefined) {
                throw new RequiredError('updatePaymentPlanTenantDeferralDTO','Required parameter updatePaymentPlanTenantDeferralDTO was null or undefined when calling updatePaymentPlanTenantDeferral.');
            }
            const localVarPath = `/v2/payment-plan/{id}/tenant-deferral`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdatePaymentPlanTenantDeferralDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updatePaymentPlanTenantDeferralDTO !== undefined ? updatePaymentPlanTenantDeferralDTO : {}) : (updatePaymentPlanTenantDeferralDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentPlansApi - functional programming interface
 * @export
 */
export const PaymentPlansApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Updates the payment date for all future instalments on a payment plan
         * @summary Change payment date for future instalments
         * @param {string} id Payment plan ID
         * @param {ChangeInstalmentDatesDTO} changeInstalmentDatesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeInstalmentDates(id: string, changeInstalmentDatesDTO: ChangeInstalmentDatesDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).changeInstalmentDates(id, changeInstalmentDatesDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create a payment plan for a user
         * @param {CreatePaymentPlanDTO} createPaymentPlanDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentPlan(createPaymentPlanDTO: CreatePaymentPlanDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPlanWithInstalmentsDTO> {
            const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).createPaymentPlan(createPaymentPlanDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a Payment Plan By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentPlanById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).deletePaymentPlanById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Force delete a Payment Plan By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceDeletePaymentPlanById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).forceDeletePaymentPlanById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a Payment Plan By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentPlanById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPlanWithInstalmentsDTO> {
            const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).getPaymentPlanById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get a Payment Plan Property Address By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentPlanPropertyAddressById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressDTO> {
            const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).getPaymentPlanPropertyAddressById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create a setup intent for a payment plan and return the secret
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetupIntentSecret(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetupIntentSecretDTO> {
            const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).getSetupIntentSecret(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Enable or disable tenant instalment deferral on a payment plan
         * @param {string} id Payment plan ID
         * @param {UpdatePaymentPlanTenantDeferralDTO} updatePaymentPlanTenantDeferralDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentPlanTenantDeferral(id: string, updatePaymentPlanTenantDeferralDTO: UpdatePaymentPlanTenantDeferralDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentPlanDTO> {
            const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).updatePaymentPlanTenantDeferral(id, updatePaymentPlanTenantDeferralDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PaymentPlansApi - factory interface
 * @export
 */
export const PaymentPlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Updates the payment date for all future instalments on a payment plan
         * @summary Change payment date for future instalments
         * @param {string} id Payment plan ID
         * @param {ChangeInstalmentDatesDTO} changeInstalmentDatesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeInstalmentDates(id: string, changeInstalmentDatesDTO: ChangeInstalmentDatesDTO, options?: any) {
            return PaymentPlansApiFp(configuration).changeInstalmentDates(id, changeInstalmentDatesDTO, options)(axios, basePath);
        },
        /**
         * Create a payment plan for a user
         * @param {CreatePaymentPlanDTO} createPaymentPlanDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPaymentPlan(createPaymentPlanDTO: CreatePaymentPlanDTO, options?: any) {
            return PaymentPlansApiFp(configuration).createPaymentPlan(createPaymentPlanDTO, options)(axios, basePath);
        },
        /**
         * Delete a Payment Plan By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePaymentPlanById(id: string, options?: any) {
            return PaymentPlansApiFp(configuration).deletePaymentPlanById(id, options)(axios, basePath);
        },
        /**
         * Force delete a Payment Plan By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forceDeletePaymentPlanById(id: string, options?: any) {
            return PaymentPlansApiFp(configuration).forceDeletePaymentPlanById(id, options)(axios, basePath);
        },
        /**
         * Get a Payment Plan By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentPlanById(id: string, options?: any) {
            return PaymentPlansApiFp(configuration).getPaymentPlanById(id, options)(axios, basePath);
        },
        /**
         * Get a Payment Plan Property Address By Id
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentPlanPropertyAddressById(id: string, options?: any) {
            return PaymentPlansApiFp(configuration).getPaymentPlanPropertyAddressById(id, options)(axios, basePath);
        },
        /**
         * Create a setup intent for a payment plan and return the secret
         * @param {string} id Payment plan id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetupIntentSecret(id: string, options?: any) {
            return PaymentPlansApiFp(configuration).getSetupIntentSecret(id, options)(axios, basePath);
        },
        /**
         * Enable or disable tenant instalment deferral on a payment plan
         * @param {string} id Payment plan ID
         * @param {UpdatePaymentPlanTenantDeferralDTO} updatePaymentPlanTenantDeferralDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePaymentPlanTenantDeferral(id: string, updatePaymentPlanTenantDeferralDTO: UpdatePaymentPlanTenantDeferralDTO, options?: any) {
            return PaymentPlansApiFp(configuration).updatePaymentPlanTenantDeferral(id, updatePaymentPlanTenantDeferralDTO, options)(axios, basePath);
        },
    };
};

/**
 * PaymentPlansApi - interface
 * @export
 * @interface PaymentPlansApi
 */
export interface PaymentPlansApiInterface {
    /**
     * Updates the payment date for all future instalments on a payment plan
     * @summary Change payment date for future instalments
     * @param {string} id Payment plan ID
     * @param {ChangeInstalmentDatesDTO} changeInstalmentDatesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    changeInstalmentDates(id: string, changeInstalmentDatesDTO: ChangeInstalmentDatesDTO, options?: any): AxiosPromise<{}>;

    /**
     * Create a payment plan for a user
     * @param {CreatePaymentPlanDTO} createPaymentPlanDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    createPaymentPlan(createPaymentPlanDTO: CreatePaymentPlanDTO, options?: any): AxiosPromise<PaymentPlanWithInstalmentsDTO>;

    /**
     * Delete a Payment Plan By Id
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    deletePaymentPlanById(id: string, options?: any): AxiosPromise<object>;

    /**
     * Force delete a Payment Plan By Id
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    forceDeletePaymentPlanById(id: string, options?: any): AxiosPromise<object>;

    /**
     * Get a Payment Plan By Id
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    getPaymentPlanById(id: string, options?: any): AxiosPromise<PaymentPlanWithInstalmentsDTO>;

    /**
     * Get a Payment Plan Property Address By Id
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    getPaymentPlanPropertyAddressById(id: string, options?: any): AxiosPromise<AddressDTO>;

    /**
     * Create a setup intent for a payment plan and return the secret
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    getSetupIntentSecret(id: string, options?: any): AxiosPromise<SetupIntentSecretDTO>;

    /**
     * Enable or disable tenant instalment deferral on a payment plan
     * @param {string} id Payment plan ID
     * @param {UpdatePaymentPlanTenantDeferralDTO} updatePaymentPlanTenantDeferralDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApiInterface
     */
    updatePaymentPlanTenantDeferral(id: string, updatePaymentPlanTenantDeferralDTO: UpdatePaymentPlanTenantDeferralDTO, options?: any): AxiosPromise<PaymentPlanDTO>;

}

/**
 * PaymentPlansApi - object-oriented interface
 * @export
 * @class PaymentPlansApi
 * @extends {BaseAPI}
 */
export class PaymentPlansApi extends BaseAPI implements PaymentPlansApiInterface {
    /**
     * Updates the payment date for all future instalments on a payment plan
     * @summary Change payment date for future instalments
     * @param {string} id Payment plan ID
     * @param {ChangeInstalmentDatesDTO} changeInstalmentDatesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public changeInstalmentDates(id: string, changeInstalmentDatesDTO: ChangeInstalmentDatesDTO, options?: any) {
        return PaymentPlansApiFp(this.configuration).changeInstalmentDates(id, changeInstalmentDatesDTO, options)(this.axios, this.basePath);
    }

    /**
     * Create a payment plan for a user
     * @param {CreatePaymentPlanDTO} createPaymentPlanDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public createPaymentPlan(createPaymentPlanDTO: CreatePaymentPlanDTO, options?: any) {
        return PaymentPlansApiFp(this.configuration).createPaymentPlan(createPaymentPlanDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete a Payment Plan By Id
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public deletePaymentPlanById(id: string, options?: any) {
        return PaymentPlansApiFp(this.configuration).deletePaymentPlanById(id, options)(this.axios, this.basePath);
    }

    /**
     * Force delete a Payment Plan By Id
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public forceDeletePaymentPlanById(id: string, options?: any) {
        return PaymentPlansApiFp(this.configuration).forceDeletePaymentPlanById(id, options)(this.axios, this.basePath);
    }

    /**
     * Get a Payment Plan By Id
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public getPaymentPlanById(id: string, options?: any) {
        return PaymentPlansApiFp(this.configuration).getPaymentPlanById(id, options)(this.axios, this.basePath);
    }

    /**
     * Get a Payment Plan Property Address By Id
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public getPaymentPlanPropertyAddressById(id: string, options?: any) {
        return PaymentPlansApiFp(this.configuration).getPaymentPlanPropertyAddressById(id, options)(this.axios, this.basePath);
    }

    /**
     * Create a setup intent for a payment plan and return the secret
     * @param {string} id Payment plan id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public getSetupIntentSecret(id: string, options?: any) {
        return PaymentPlansApiFp(this.configuration).getSetupIntentSecret(id, options)(this.axios, this.basePath);
    }

    /**
     * Enable or disable tenant instalment deferral on a payment plan
     * @param {string} id Payment plan ID
     * @param {UpdatePaymentPlanTenantDeferralDTO} updatePaymentPlanTenantDeferralDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentPlansApi
     */
    public updatePaymentPlanTenantDeferral(id: string, updatePaymentPlanTenantDeferralDTO: UpdatePaymentPlanTenantDeferralDTO, options?: any) {
        return PaymentPlansApiFp(this.configuration).updatePaymentPlanTenantDeferral(id, updatePaymentPlanTenantDeferralDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for PaymentPlansApi
 * Import individual functions for optimal bundle size
 */
/**
 * Updates the payment date for all future instalments on a payment plan
 * @summary Change payment date for future instalments
 * @param {string} id Payment plan ID
 * @param {ChangeInstalmentDatesDTO} changeInstalmentDatesDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function changeInstalmentDates(
    id: string,
    changeInstalmentDatesDTO: ChangeInstalmentDatesDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).changeInstalmentDates(id, changeInstalmentDatesDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create a payment plan for a user
 * @param {CreatePaymentPlanDTO} createPaymentPlanDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createPaymentPlan(
    createPaymentPlanDTO: CreatePaymentPlanDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PaymentPlanWithInstalmentsDTO> {
    const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).createPaymentPlan(createPaymentPlanDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a Payment Plan By Id
 * @param {string} id Payment plan id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deletePaymentPlanById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).deletePaymentPlanById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Force delete a Payment Plan By Id
 * @param {string} id Payment plan id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function forceDeletePaymentPlanById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).forceDeletePaymentPlanById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a Payment Plan By Id
 * @param {string} id Payment plan id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getPaymentPlanById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PaymentPlanWithInstalmentsDTO> {
    const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).getPaymentPlanById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get a Payment Plan Property Address By Id
 * @param {string} id Payment plan id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getPaymentPlanPropertyAddressById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<AddressDTO> {
    const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).getPaymentPlanPropertyAddressById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create a setup intent for a payment plan and return the secret
 * @param {string} id Payment plan id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getSetupIntentSecret(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SetupIntentSecretDTO> {
    const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).getSetupIntentSecret(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Enable or disable tenant instalment deferral on a payment plan
 * @param {string} id Payment plan ID
 * @param {UpdatePaymentPlanTenantDeferralDTO} updatePaymentPlanTenantDeferralDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updatePaymentPlanTenantDeferral(
    id: string,
    updatePaymentPlanTenantDeferralDTO: UpdatePaymentPlanTenantDeferralDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PaymentPlanDTO> {
    const localVarAxiosArgs = PaymentPlansApiAxiosParamCreator(configuration).updatePaymentPlanTenantDeferral(id, updatePaymentPlanTenantDeferralDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

